import React from 'react'
import styled from 'styled-components'

import ConfirmLine, { ConfirmLineProps } from '../items/ConfirmLine'
import ItemBox from '../items/ItemBox'

/**
 * 確認画面で利用する確認項目の一覧
 */
const ConfirmList: React.FC<ConfirmListProps> = (props) => {
  return (
    <React.Fragment>
      {props.items.map((item, index) => (
        <ConfirmLineArea key={index} isRequest={props.isRequest}>
          <ItemBox>
            <ConfirmLine
              isConfirm={props.isConfirm}
              isRequest={props.isRequest}
              {...item}
            />
          </ItemBox>
        </ConfirmLineArea>
      ))}
    </React.Fragment>
  )
}

export type ConfirmListProps = {
  items: Array<ConfirmLineProps>
  isConfirm?: boolean
  isRequest?: boolean
}

const ConfirmLineArea = styled.div<{ isRequest?: boolean }>`
  ${(props): string =>
    props.isRequest
      ? `
    margin-bottom: -1px;
    &&:last-child {
      margin-bottom: 0;
    }
  `
      : `
    margin-bottom: 16px;
    &&:first-child {
      margin-top: 16px;
    }
    &&:last-child {
      margin-bottom: 0;
    }
  `}
`

export default React.memo<ConfirmListProps>(ConfirmList)
